import React, { useState, useEffect } from 'react';
// import io from 'socket.io';
import { makeStyles } from '@mui/styles';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { blue, pink } from '@mui/material/colors';
import CircularProgress from '@mui/material/CircularProgress';
import LinearProgress from '@mui/material/LinearProgress';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

import './App.css';

const darkTheme = createTheme({
  palette: {
    type: 'dark',
    primary: blue,
    secondary: pink,
  },
});

const useStyles = makeStyles(theme => ({
  spaceBelow: {
    marginBottom: darkTheme.spacing(1),
  },
  spaceRight: {
    marginRight: darkTheme.spacing(1),
  },
  inline: {
    display: 'inline-block',
  },
}));

function App() {
  const [connected, setConnected] = useState(true);
  const [downloadingPages, setDownloadingPages] = useState(false);
  const [downloadingFile, setDownloadingFile] = useState(false);
  const [starting, setStarting] = useState(false);
  const [error, setError] = useState('');
  const [url, setUrl] = useState('');
  const [currentProgress, setCurrentProgress] = useState(0);
  const [totalProgress, setTotalProgress] = useState(0);
  const [socket] = useState();

  useEffect(() => {
    // const socket = io.connect({
    //   path: '/soc'
    // });
    // setSocket(socket);
    // socket.on('connect', () => {
    //   setConnected(true);
    // });
    // socket.on('disconnect', () => {
    //   setConnected(false);
    // });
    // socket.on('starting', () => {
    //   setDownloadingPages(true);
    //   setStarting(false);
    // });
    // socket.on('progress', ({ total, completed }) => {
    //   setTotalProgress(total);
    //   setCurrentProgress(completed);
    //   if (total === completed) {
    //     setDownloadingPages(false);
    //     setDownloadingFile(true);
    //   }
    // });
    // socket.on('done', ({ path }) => {
    //   setDownloadingFile(true);
    //   setDownloadingPages(false);
    //   setUrl(path);
    // });
    // socket.on('oops', ({ error }) => {
    //   setError(error);
    // });
    // socket.on('disconnect', (reason) => {
    //   if (reason === 'io server disconnect' || reason === 'io client disconnect') {
    //     socket.connect();
    //   }
    // });
  }, []);

  const classes = useStyles();

  let page;
  if (!connected) {
    page = (
      <div>
        <CircularProgress />
        <div>
          Connecting
        </div>
      </div>
    );
  } else if (error) {
    page = (
      <div>
        <div className={classes.spaceBelow}>
          {error}
        </div>
        <div>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setError('');
            }}
          >
            Back
          </Button>
        </div>
      </div>
    );
  } else if (downloadingPages) {
    page = (
      <div>
        <LinearProgress variant="determinate" value={currentProgress/totalProgress*100} />
        <div>
          Downloading Pages
        </div>
      </div>
    );
  } else if (downloadingFile) {
    page = (
      <div>
        <div className={classes.spaceBelow}>
          PDF ready. Click the button to download. Do not close this window until your download has finished.
        </div>
        <div>
          <div className={`${classes.inline} ${classes.spaceRight}`}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              onClick={() => {
                const win = window.open(url, '_blank');
                win.focus();
              }}
            >
              Download
            </Button>
          </div>
          <div className={classes.inline}>
            <Button
              variant="contained"
              onClick={() => {
                setConnected(false);
                setDownloadingPages(false);
                setDownloadingFile(false);
                setStarting(false);
                setError('');
                setUrl('');
                setCurrentProgress(0);
                setTotalProgress(0);
                socket.disconnect();
              }}
            >
              Finish
            </Button>
          </div>
        </div>
      </div>
    );
  } else {
    page = (
      <div>
        <div className={classes.spaceBelow}>
          <TextField label="Enter URL" value={url} onChange={evt => setUrl(evt.target.value)} />
        </div>
        <div>
          <Button
            variant="contained"
            color="primary"
            disabled={starting}
            onClick={() => {
              setStarting(true);
              socket.emit('start', { url });
            }}
          >
            Download
          </Button>
        </div>
      </div>
    );
  }

  return (
    <ThemeProvider theme={darkTheme}>
      <div className="App">
        <header className="App-header">
          {page}
        </header>
      </div>
    </ThemeProvider>
  );
}

export default App;
